import * as React from 'react';
import moment from 'moment';
import { connect, Dispatch } from 'react-redux';

import { ICalendarAppState } from '../redux-state';
import { nextMonth } from '../redux-state/actions/calendar.actions';
import CalendarText from '../contexts/calendar-text';

interface ILoadMoreExternalProps {
    loadMoreSideEffect: () => void;
}

interface StateToProps {
    updating: boolean;
}

interface DispatchToProps {
    loadMore: () => void;
}

export type LoadMoreProps = StateToProps & DispatchToProps & ILoadMoreExternalProps;

/**
 * Trigger to load more dates. Loads the next month if no queryString date-range is applied, clears the date-range if there is one.
 */
export class LoadMore extends React.Component<LoadMoreProps, any> {
    constructor(props: LoadMoreProps) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        if (!this.props.updating) {
            this.props.loadMoreSideEffect();
            this.props.loadMore();
           
        }
    }

    render() {
        return (
            <CalendarText.Consumer>
                {text => (
                    <button type="button" className="ace-cal-list-load-more btn-outline space-top-lg" onClick={this.onClick}>
                        {text.loadMoreEventsButtonText}
                    </button>
                )}
            </CalendarText.Consumer>
        )
    }
}

function mapStateToProps(state: ICalendarAppState): StateToProps {
    return {
        updating: state.calendar.updating
    }
}

function mapDispatchToProps(dispatch: Dispatch): DispatchToProps {
    return {
        loadMore: () => { dispatch(nextMonth()); }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoadMore);